import * as ng from 'angular';
import { ComponentRegistration } from '../core';
import { ISessionService, ICustomerSettingsService } from '../services';
import { ISiteConfigService  } from '../core';
import { IAuthService } from '../components/security';
import {  Dto } from '../data';
let template = require('./header-bar.html');
let emptyLogoPath = require('../assets/img/emptylogo.jpg');

class HeaderBarComponent extends ComponentRegistration {

    constructor() {
        super('headerBar', {
            controller: HeaderBarController,
            templateUrl: template,
            controllerAs: 'headerBar',
            bindings: {
            }
        });
    }
}

interface IHeaderBarController {
    activate(): void;
    onCustomerMenuButtonClick(): void;
    onSessionRefresh(current): void;
    onLogoutClick(): void
    onLanguageChange(): any;
}

class HeaderBarController implements IHeaderBarController {
    private static $inject: Array<string> = ['$window', '$scope', '$rootRouter', 'SiteConfig', 'Session', 'Auth', 'CustomerSettings'];

    public emptyLogo = emptyLogoPath;
    //private fields
    private session: any = {};
    private languages: Array<any> = [];
    private customerSettings: Dto.IContentSettings = {} as Dto.IContentSettings;

    constructor(private $window: ng.IWindowService,
        private $scope: ng.IScope,
        private $rootRouter: ng.Router,
        private SiteConfig: ISiteConfigService,
        private Session: ISessionService,
        private Auth: IAuthService,
        private CustomerSettings: ICustomerSettingsService) {

        this.activate();
    }

    public activate(): void {
        console.log("headerBar controller loaded.");

        this.CustomerSettings.getLanguageSettings()
            .then((language) => {
                this.languages = language.languages;
            });

        this.CustomerSettings.getContentSettings()
            .then((content) => {
                this.customerSettings = content;
            });

        this.Session.registerRefreshHandler((current) => { this.onSessionRefresh(current) });
        this.Session.getSessionAsync()
            .then((current) => {
                this.session = current;
            });

        console.log("headerBar controller activated.");
    }

    public onCustomerMenuButtonClick(): void {
        this.$window.location.href = this.customerSettings.menuButton.hyperlink;
    }

    public onSessionRefresh(current): void {
        this.session = current;
    }

    public onLogoutClick(): void {
        this.session = this.Session.reset();
        this.$rootRouter.navigate(['Home']);
        //this.$window.location.reload();
    }

    public onLanguageChange(): void {
        this.Session.setLanguage(this.session.language);
    }

    public get logoPath(): string {
        var headerLogo = this.customerSettings.headerLogo;
        return (headerLogo) ? headerLogo.src : null || this.emptyLogo;      
    }

}

let hbarComponent = new HeaderBarComponent();
export default hbarComponent;
export { hbarComponent as HeaderBarComponent, IHeaderBarController, HeaderBarController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/header-bar.ts